import { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Navbar.css";

const Navbar = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (

        <header className="nav-main">

            <div className="nav-header">

                <h1 className="nav-logo" onClick={() => navigate("/")} >Anubhava Montessori <span>.</span></h1>

                <div className="mobile-menu-icon" onClick={toggleMenu}>
                    <i className={isOpen ? "fas fa-times" : "fas fa-bars"}></i>
                </div>

                <ul className={isOpen ? "nav-links active" : "nav-links"} >

                    <li onClick={() => { navigate("/"); setIsOpen(false); }} >Home</li>
                    <li onClick={() => {
                        if (window.location.pathname === "/") {
                            document.getElementById("learn_more")?.scrollIntoView({ behavior: "smooth" });
                        } else {
                            window.location.href = "/#learn_more";
                        }
                        setIsOpen(false);
                    }}
                    >Programs </li>
                    <li onClick={() => { navigate("/about-us"); setIsOpen(false); }} >About Us</li>
                    <li onClick={() => { navigate("/montessori"); setIsOpen(false); }} >Montessori</li>
                    <li onClick={() => { navigate("/blogs"); setIsOpen(false); }} >Blogs</li>

                    {/* <li onClick={() => { navigate("/contact"); setIsOpen(false); }} >Contact Us</li> */}
                    <li onClick={() => { navigate("/gallery"); setIsOpen(false); }} >Gallery</li>
                    <li className="mobile-btn"><button className="get-started-btn-mobile" onClick={() => { setIsOpen(false); window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank"); }}>Enroll Now</button></li>

                </ul>

                <button className="get-started-btn desktop-btn" onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")}>Enroll Now</button>

            </div>

        </header>

    );
};

export default Navbar;